import React, { useLayoutEffect, useState } from "react";
import PropTypes from "prop-types";

const Form = ({ unidad, errors }) => {
	const [form, setForm] = useState({
		id: "",
		codigo: "",
		nombre: "",
		abreviatura: "",
		tipo: "",
		codigo_dgii: "",
		activa: true,
	});

	const handleFormInputChange = (input, inputChanged) => {
		setForm((form) => ({
			...form,
			[inputChanged]: input,
		}));
	};

	useLayoutEffect(() => {
		if (Object.keys(unidad).length === 0) return;

		setForm({
			id: unidad.id || "",
			codigo: unidad.codigo || "",
			nombre: unidad.nombre || "",
			abreviatura: unidad.abreviatura || "",
			tipo: unidad.tipo || "",
			codigo_dgii: unidad.codigo_dgii || "",
			activa: unidad.activa ?? true,
		});
	}, [unidad]);

	return (
		<div className="popup__body">
			<input type="hidden" name="id" value={form.id} />
			<div className="row form-group">
				<div className="col col-md-4">
					<label className="label form-control-label">Código:</label>
				</div>
				<div className="col col-md-8">
					<input
						type="text"
						name="codigo"
						onChange={(e) =>
							handleFormInputChange(e.target.value, "codigo")
						}
						value={form.codigo}
						className="form-control"
					/>
					{errors.codigo && (
						<small className="help-blockParams form-Text">
							{errors.codigo[0]}
						</small>
					)}
				</div>
			</div>
			<div className="row form-group">
				<div className="col col-md-4">
					<label className="label form-control-label">Nombre:</label>
				</div>
				<div className="col col-md-8">
					<input
						type="text"
						name="nombre"
						onChange={(e) =>
							handleFormInputChange(e.target.value, "nombre")
						}
						value={form.nombre}
						className="form-control"
					/>
					{errors.nombre && (
						<small className="help-blockParams form-Text">
							{errors.nombre[0]}
						</small>
					)}
				</div>
			</div>
			<div className="row form-group">
				<div className="col col-md-4">
					<label className="label form-control-label">
						Abreviatura:
					</label>
				</div>
				<div className="col col-md-8">
					<input
						type="text"
						name="abreviatura"
						onChange={(e) =>
							handleFormInputChange(e.target.value, "abreviatura")
						}
						value={form.abreviatura}
						className="form-control"
					/>
					{errors.abreviatura && (
						<small className="help-blockParams form-Text">
							{errors.abreviatura[0]}
						</small>
					)}
				</div>
			</div>
			<div className="row form-group">
				<div className="col col-md-4">
					<label className="label form-control-label">Tipo:</label>
				</div>
				<div className="col col-md-8">
					<select
						name="tipo"
						className="form-control"
						value={form.tipo}
						onChange={(e) =>
							handleFormInputChange(e.target.value, "tipo")
						}
					>
						<option value="">- Sin definir -</option>
						<option value="conteo">Conteo</option>
						<option value="peso">Peso</option>
						<option value="volumen">Volumen</option>
						<option value="longitud">Longitud</option>
					</select>
					{errors.tipo && (
						<small className="help-blockParams form-Text">
							{errors.tipo[0]}
						</small>
					)}
				</div>
			</div>
			<div className="row form-group">
				<div className="col col-md-4">
					<label className="label form-control-label">
						Código DGII:
					</label>
				</div>
				<div className="col col-md-8">
					<input
						type="text"
						name="codigo_dgii"
						onChange={(e) =>
							handleFormInputChange(e.target.value, "codigo_dgii")
						}
						value={form.codigo_dgii}
						className="form-control"
					/>
					{errors.codigo_dgii && (
						<small className="help-blockParams form-Text">
							{errors.codigo_dgii[0]}
						</small>
					)}
				</div>
			</div>
			<div className="row form-group">
				<div className="col col-md-4">
					<label className="label form-control-label">Activa:</label>
				</div>
				<div className="col col-md-8">
					<input type="hidden" name="activa" value="0" />
					<label className="switch switch-3d switch-success mr-3">
						<input
							type="checkbox"
							className="switch-input"
							name="activa"
							value="1"
							checked={form.activa}
							onChange={(e) =>
								handleFormInputChange(e.target.checked, "activa")
							}
						/>
						<span className="switch-label" />
						<span className="switch-handle" />
					</label>
					{errors.activa && (
						<small className="help-blockParams form-Text">
							{errors.activa[0]}
						</small>
					)}
				</div>
			</div>
		</div>
	);
};

Form.propTypes = {
	errors: PropTypes.object,
	unidad: PropTypes.object,
};

export default Form;
